export default function inclusion(value = '', options = {}) {
  if ((options.list || []).indexOf(value) > -1) {
    return false;
  }

  return true;
}

inclusion.message = function message(value, options = {}) {
  return options.message || 'não pertence à lista';
};
